module.exports = __webpack_public_path__ + "static/media/la-regular-400.88d9d941.woff2";